import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import TitleBannerEnquiry from "../components/titleBanner/TitleBannerEnquiry"
import BlogsList from "../components/blog/blogs-list/BlogsList"
import LatestBlog from "../components/blog/latestBlog/LatestBlog"
import Subscription from "../components/home/subscriptionSection/Subscription"
import { getBlogCollectionJsonLd } from "../utils/jsonld"

let BlogPage = ({ data }) => {
  const posts = data.allContentfulAiaBlog.edges.map(edge => edge.node)
  return (
    <>
      <SEO
        title="All BIM & CAD Modeling Courses | BIM & CAD Training Center"
        description="Ace Industrial Academy conducts BIM courses for Autocad 2D/3D, Revit, Synchro 4D, OpenPlant, and more"
        jsonLd={getBlogCollectionJsonLd(posts)}
      />
      <TitleBannerEnquiry
        title="Blogs"
        description="Read and enjoy our collection of articles on the skills-in-demand by the industry.        "
        withOnlyDescription
        hasPlainBanner
      />

      <LatestBlog />

      <BlogsList />
      <Subscription />
    </>
  )
}

export const allQuery = graphql`
  query allBlogQuery {
    allContentfulAiaBlog {
      edges {
        node {
          id
          slug
          title
          description
          coverPhoto {
            fluid(
              maxWidth: 400
              maxHeight: 250
              resizingBehavior: SCALE
            ) {
              ...GatsbyContentfulFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`

export default BlogPage
